// /var/www/website2023/aaa-aa.site/website2023/s-293-spatime-dev/src/components/calculateRowSpan.js

export const calculateRowSpan = (columnData, serviceTime) => {
    return columnData.filter(item => item.ServiceTime === serviceTime).length;
};

